/* tslint:disable */
/* eslint-disable */
export enum QuestionnairePage {
    BuildingFunctions = 'BUILDING_FUNCTIONS',
    Questions = 'QUESTIONS',
    Summary = 'SUMMARY'
}
